/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CreateCoachProviderQueryVariables = {
    userId: string;
};
export type CreateCoachProviderQueryResponse = {
    readonly user_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"CreateCoachView_user" | "ProfileStep_user" | "CoachingStep_user" | "AvailabilityLessonsStep_user" | "VideoStep_user" | "BusinessStep_user">;
            };
        }>;
    };
};
export type CreateCoachProviderQuery = {
    readonly response: CreateCoachProviderQueryResponse;
    readonly variables: CreateCoachProviderQueryVariables;
};



/*
query CreateCoachProviderQuery(
  $userId: String!
) {
  user_connection(where: {id: {_eq: $userId}}) {
    edges {
      node {
        id
        ...CreateCoachView_user
        ...ProfileStep_user
        ...CoachingStep_user
        ...AvailabilityLessonsStep_user
        ...VideoStep_user
        ...BusinessStep_user
      }
    }
  }
}

fragment AvailabilityLessonsStep_user on user {
  id
  coach {
    id
    cuid
    coachAvailabilities {
      id
      cuid
      dayOfTheWeek
      isAvailable
      startSeconds
      endSeconds
    }
  }
}

fragment BusinessStep_user on user {
  coach {
    cuid
    coachLessons {
      id
    }
    coachDisciplines {
      cuid
      name
      skills
      abilityLevelRange
      id
    }
    coachStudents {
      cuid
      ageRange
      genders
      focus
      id
    }
    id
  }
}

fragment CoachingStep_user on user {
  stripeConnectAccount {
    payoutsEnabled
    chargesEnabled
    id
  }
  coach {
    cuid
    coachLocations {
      cuid
      zipCode
      addressLine1
      googlePlaceId
      lat
      lng
      city
      state
      country
      countryCode
      timezone
      fullAddress
      coachCuid
      id
    }
    lessonLocations(where: {deleted_at: {_is_null: true}}) {
      cuid
      isDefault
      lat
      lng
      city
      state
      zipCode
      country
      countryCode
      googlePlaceId
      address
      addressLine1
      addressLine2
      label
      coachCuid
      timezone
      id
    }
    coachDisciplines {
      cuid
      name
      skills
      abilityLevelRange
      id
    }
    coachStudents {
      cuid
      ageRange
      genders
      focus
      id
    }
    id
  }
}

fragment CreateCoachView_user on user {
  isCoach
  coachSetupStep
  coachCuid
}

fragment ProfileStep_user on user {
  id
  coach {
    id
    cuid
    about
    tagline
    coachingVibe
  }
}

fragment VideoStep_user on user {
  id
  coach {
    id
    cuid
    introVideoUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        } as any
    ], v1 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "_eq",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "id"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "coachCuid",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipCode",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressLine1",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "googlePlaceId",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lng",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateCoachProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "userConnection",
                    "kind": "LinkedField",
                    "name": "user_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "userEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "user",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CreateCoachView_user"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ProfileStep_user"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CoachingStep_user"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AvailabilityLessonsStep_user"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VideoStep_user"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "BusinessStep_user"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateCoachProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "userConnection",
                    "kind": "LinkedField",
                    "name": "user_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "userEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "user",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCoach",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "coachSetupStep",
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "coach",
                                            "kind": "LinkedField",
                                            "name": "coach",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v4 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "about",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "tagline",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "coachingVibe",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "coachLocation",
                                                    "kind": "LinkedField",
                                                    "name": "coachLocations",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v14 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "fullAddress",
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "where",
                                                            "value": {
                                                                "deleted_at": {
                                                                    "_is_null": true
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "lessonLocation",
                                                    "kind": "LinkedField",
                                                    "name": "lessonLocations",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isDefault",
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v5 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "address",
                                                            "storageKey": null
                                                        },
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addressLine2",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "label",
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": "lessonLocations(where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "coachDiscipline",
                                                    "kind": "LinkedField",
                                                    "name": "coachDisciplines",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "skills",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "abilityLevelRange",
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "coachStudent",
                                                    "kind": "LinkedField",
                                                    "name": "coachStudents",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "ageRange",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "genders",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "focus",
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "coachAvailability",
                                                    "kind": "LinkedField",
                                                    "name": "coachAvailabilities",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "dayOfTheWeek",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAvailable",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startSeconds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endSeconds",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "introVideoUrl",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "coachLesson",
                                                    "kind": "LinkedField",
                                                    "name": "coachLessons",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "stripeConnectAccount",
                                            "kind": "LinkedField",
                                            "name": "stripeConnectAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "payoutsEnabled",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "chargesEnabled",
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "56c970218f1c797141459312b1eac9c5",
            "id": null,
            "metadata": {},
            "name": "CreateCoachProviderQuery",
            "operationKind": "query",
            "text": "query CreateCoachProviderQuery(\n  $userId: String!\n) {\n  user_connection(where: {id: {_eq: $userId}}) {\n    edges {\n      node {\n        id\n        ...CreateCoachView_user\n        ...ProfileStep_user\n        ...CoachingStep_user\n        ...AvailabilityLessonsStep_user\n        ...VideoStep_user\n        ...BusinessStep_user\n      }\n    }\n  }\n}\n\nfragment AvailabilityLessonsStep_user on user {\n  id\n  coach {\n    id\n    cuid\n    coachAvailabilities {\n      id\n      cuid\n      dayOfTheWeek\n      isAvailable\n      startSeconds\n      endSeconds\n    }\n  }\n}\n\nfragment BusinessStep_user on user {\n  coach {\n    cuid\n    coachLessons {\n      id\n    }\n    coachDisciplines {\n      cuid\n      name\n      skills\n      abilityLevelRange\n      id\n    }\n    coachStudents {\n      cuid\n      ageRange\n      genders\n      focus\n      id\n    }\n    id\n  }\n}\n\nfragment CoachingStep_user on user {\n  stripeConnectAccount {\n    payoutsEnabled\n    chargesEnabled\n    id\n  }\n  coach {\n    cuid\n    coachLocations {\n      cuid\n      zipCode\n      addressLine1\n      googlePlaceId\n      lat\n      lng\n      city\n      state\n      country\n      countryCode\n      timezone\n      fullAddress\n      coachCuid\n      id\n    }\n    lessonLocations(where: {deleted_at: {_is_null: true}}) {\n      cuid\n      isDefault\n      lat\n      lng\n      city\n      state\n      zipCode\n      country\n      countryCode\n      googlePlaceId\n      address\n      addressLine1\n      addressLine2\n      label\n      coachCuid\n      timezone\n      id\n    }\n    coachDisciplines {\n      cuid\n      name\n      skills\n      abilityLevelRange\n      id\n    }\n    coachStudents {\n      cuid\n      ageRange\n      genders\n      focus\n      id\n    }\n    id\n  }\n}\n\nfragment CreateCoachView_user on user {\n  isCoach\n  coachSetupStep\n  coachCuid\n}\n\nfragment ProfileStep_user on user {\n  id\n  coach {\n    id\n    cuid\n    about\n    tagline\n    coachingVibe\n  }\n}\n\nfragment VideoStep_user on user {\n  id\n  coach {\n    id\n    cuid\n    introVideoUrl\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'aebc91132c97315ab283754ba5ebb41d';
export default node;
